/**
 * OMNIVASO i18n Module — Spanish (es)
 * Hand-curated. All keys must mirror en.js exactly.
 */
const es = {
    nav: {
        home:            'Inicio',
        shop:            'Tienda',
        cart:            'Carrito',
        search:          'Buscar',
        articles:        'Artículos',
        blog:            'Blog',
        about:           'Acerca de',
        contact:         'Contacto',
        account:         'Mi cuenta',
        orders:          'Mis pedidos',
        login:           'Iniciar sesión',
        logout:          'Cerrar sesión',
        openMenu:        'Abrir menú',
        closeMenu:       'Cerrar menú',
        skipToContent:   'Saltar al contenido',
    },

    actions: {
        readMore:        'Leer más',
        viewAll:         'Ver todo',
        learnMore:       'Más información',
        back:            'Volver',
        close:           'Cerrar',
        save:            'Guardar',
        cancel:          'Cancelar',
        submit:          'Enviar',
        confirm:         'Confirmar',
        delete:          'Eliminar',
        edit:            'Editar',
        add:             'Añadir',
        remove:          'Quitar',
        search:          'Buscar',
        reset:           'Restablecer',
        next:            'Siguiente',
        previous:        'Anterior',
        loading:         'Cargando...',
        tryAgain:        'Intentar de nuevo',
        copy:            'Copiar',
        share:           'Compartir',
        download:        'Descargar',
        upload:          'Subir',
        apply:           'Aplicar',
        clear:           'Limpiar',
    },

    status: {
        success:         '¡Éxito!',
        error:           'Ocurrió un error. Por favor, inténtelo de nuevo.',
        saved:           'Guardado correctamente.',
        notFound:        'Página no encontrada.',
        comingSoon:      'Próximamente.',
        outOfStock:      'Sin existencias',
        inStock:         'En stock',
        soldOut:         'Agotado',
        new:             'Nuevo',
        sale:            'Oferta',
        featured:        'Destacado',
        noResults:       'No se encontraron resultados.',
        required:        'Este campo es obligatorio.',
        invalidEmail:    'Por favor, ingrese una dirección de correo válida.',
    },

    shop: {
        addToCart:       'Añadir al carrito',
        addedToCart:     'Añadido al carrito',
        viewCart:        'Ver carrito',
        checkout:        'Finalizar compra',
        continueShopping:'Seguir comprando',
        orderSummary:    'Resumen del pedido',
        orderTotal:      'Total del pedido',
        subtotal:        'Subtotal',
        shipping:        'Envío',
        tax:             'Impuestos',
        discount:        'Descuento',
        couponCode:      'Código de cupón',
        applyCoupon:     'Aplicar cupón',
        quantity:        'Cantidad',
        price:           'Precio',
        total:           'Total',
        remove:          'Quitar',
        emptyCart:       'Tu carrito está vacío.',
        browseProducts:  'Explorar productos',
        product:         'Producto',
        products:        'Productos',
        category:        'Categoría',
        categories:      'Categorías',
        sortBy:          'Ordenar por',
        filterBy:        'Filtrar por',
        allProducts:     'Todos los productos',
        searchProducts:  'Buscar productos...',
        productDetails:  'Detalles del producto',
        relatedProducts: 'Productos relacionados',
        stockLeft:       'unidades disponibles',
        freeShipping:    'Envío gratis',
        placeOrder:      'Realizar pedido',
        orderConfirmed:  '¡Pedido confirmado!',
        trackOrder:      'Rastrear pedido',
        orderNumber:     'Número de pedido',
        paymentMethod:   'Método de pago',
        billingAddress:  'Dirección de facturación',
        shippingAddress: 'Dirección de envío',
        firstName:       'Nombre',
        lastName:        'Apellido',
        email:           'Correo electrónico',
        phone:           'Número de teléfono',
        address:         'Dirección',
        city:            'Ciudad',
        province:        'Provincia / Estado',
        postalCode:      'Código postal',
        country:         'País',
        secureCheckout:  'Pago seguro',
        payWith:         'Pagar con',
    },

    articles: {
        by:              'Por',
        publishedOn:     'Publicado el',
        minuteRead:      'min de lectura',
        tags:            'Etiquetas',
        share:           'Compartir este artículo',
        relatedArticles: 'Artículos relacionados',
        allArticles:     'Todos los artículos',
        noArticles:      'No se encontraron artículos.',
        searchArticles:  'Buscar artículos...',
    },

    search: {
        placeholder:     'Buscar productos, artículos, páginas...',
        results:         'Resultados',
        noResults:       'No se encontraron resultados para',
        searching:       'Buscando...',
        searchTip:       'Presione ⌘K o Ctrl+K para buscar',
        quickSearch:     'Búsqueda rápida',
    },

    newsletter: {
        subscribe:       'Suscribirse',
        subscribeTitle:  'Mantente al día',
        subscribeDesc:   'Recibe las últimas novedades en tu bandeja de entrada.',
        emailPlaceholder:'Ingresa tu correo',
        thankYou:        '¡Gracias por suscribirte!',
        alreadySubscribed:'Ya estás suscrito.',
        privacyNote:     'Respetamos tu privacidad. Cancela la suscripción en cualquier momento.',
    },

    footer: {
        rights:          'Todos los derechos reservados.',
        privacy:         'Política de privacidad',
        terms:           'Términos de uso',
        sitemap:         'Mapa del sitio',
        poweredBy:       'Impulsado por',
        contactUs:       'Contáctanos',
        followUs:        'Síguenos',
        quickLinks:      'Enlaces rápidos',
    },

    forms: {
        email:           'Correo electrónico',
        password:        'Contraseña',
        confirmPassword: 'Confirmar contraseña',
        username:        'Nombre de usuario',
        name:            'Nombre',
        message:         'Mensaje',
        subject:         'Asunto',
        send:            'Enviar',
        sending:         'Enviando...',
        sent:            '¡Mensaje enviado!',
        signIn:          'Iniciar sesión',
        signUp:          'Registrarse',
        forgotPassword:  '¿Olvidaste tu contraseña?',
        rememberMe:      'Recuérdame',
        changePassword:  'Cambiar contraseña',
        currentPassword: 'Contraseña actual',
        newPassword:     'Nueva contraseña',
    },

    i18n: {
        selectLanguage:  'Seleccionar idioma',
        language:        'Idioma',
    },

    errors: {
        pageNotFound:    'Página no encontrada',
        pageNotFoundDesc:'La página que buscas no existe o ha sido movida.',
        goHome:          'Ir a la página de inicio',
        somethingWrong:  'Algo salió mal',
        somethingWrongDesc: 'Ocurrió un error inesperado. Tus datos están seguros.',
        returnToStorefront: 'Volver a la tienda',
    },
};

export default es;
